import {OwnerType} from '@/Constant';

export function isPersonal(repository?: Repository | null) {
    return !!repository && repository?.ownerType === OwnerType.User;
}

export function fixRepositoryName(repository: Repository) {
    if (isPersonal(repository)) {
        repository.name = `${repository.name}的知识库`;
    }
}
